import {QueryParamsEnum} from 'presentation/constants';
import {stringfyDate} from 'presentation/utils';
import {useState} from 'react';
import {useQueryParams} from '../../hooks';

export function useFilterByDatePicker() {
	const {setSearchParams} = useQueryParams();

	const getThreeMonthsAgo = (): Date => {
		const today = new Date();
		const threeMonthsAgo = new Date(today);
		threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
		return threeMonthsAgo;
	};

	const [currentFirstDate, setCurrentFirstDate] = useState<Date | null>();
	const [currentSecondDate, setCurrentSecondDate] = useState<Date | null>();
	const [openModalDatePickerState, setOpenModalDatePickerState] = useState(false);

	const handleSelectFirstDate = (firstDate: Date | null) => {
		if (firstDate) {
			setCurrentFirstDate(firstDate);
			setSearchParams(
				prev => {
					prev.set(QueryParamsEnum.INITIAL_DATE, stringfyDate(firstDate, 'dd/MM/yyyy'));
					return prev;
				},
				{replace: true},
			);
		}
	};

	const handleSelectSecondDate = (secondDate: Date | null) => {
		if (secondDate) {
			setCurrentSecondDate(secondDate);
			setSearchParams(
				prev => {
					prev.set(QueryParamsEnum.FINAL_DATE, stringfyDate(secondDate, 'dd/MM/yyyy'));
					return prev;
				},
				{replace: true},
			);
		}
	};

	const handleClearDates = () => {
		const defaultFirstDate = getThreeMonthsAgo();
		const defaultSecondDate = new Date();

		setCurrentFirstDate(null);
		setCurrentSecondDate(null);

		setSearchParams(
			prev => {
				prev.set(
					QueryParamsEnum.INITIAL_DATE,
					stringfyDate(defaultFirstDate, 'dd/MM/yyyy'),
				);
				prev.set(QueryParamsEnum.FINAL_DATE, stringfyDate(defaultSecondDate, 'dd/MM/yyyy'));
				return prev;
			},
			{replace: true},
		);
	};

	const openModalExternally = (open: boolean) => {
		setOpenModalDatePickerState(open);
	};

	return {
		currentFirstDate,
		currentSecondDate,
		handleSelectFirstDate,
		handleSelectSecondDate,
		handleClearDates,
		getThreeMonthsAgo,
		openModalExternally,
		openModalDatePickerState,
	};
}
